export default __webpack_public_path__ + "static/media/ClosedDoorBGFull.78994eaa.png";